export class CartSamples extends HTMLElement {
    constructor() {
        super();

        this._selectors = {
            checkbox: "[js-sample-checkbox]",
        };
    }

    connectedCallback() {
        this.checkboxes = this.querySelectorAll(this._selectors.checkbox);
        this.count = 0;
        this.limit = this.dataset.limit;

        this._evaluateCart();

        this.checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("click", this._evaluateCheckboxes);
        });
    }

    _evaluateCart = async () => {
        const data = await this._fetchCart();
        data.items.forEach((item) => {
            if (item.properties._sample) {
                this.count += 1;
            }
        });

        if (this.count === this.limit) {
            this.checkboxes.forEach((checkbox) => {
                checkbox.disabled = true;
            });
        }
    };

    async _fetchCart() {
        return fetch(`${window.routes.cart_url}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return data;
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    _evaluateCheckboxes = (evt) => {
        if (evt.target.checked) {
            this.count += 1;
        } else {
            this.count -= 1;
        }

        this.checkboxes.forEach((checkbox) => {
            if (this.count === this.limit && !checkbox.checked) {
                checkbox.disabled = true;
            } else if (this.count < this.limit && !checkbox.checked) {
                checkbox.disabled = false;
            }
        });
    };
}
